import unescapedText from 'I18n/utils/unescapedText';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getLabelText = sort => {
  if (sort === 'ascending') {
    return unescapedText('ui.UISortTH.ascendingSort');
  }
  if (sort === 'descending') {
    return unescapedText('ui.UISortTH.descendingSort');
  }
  return unescapedText('ui.UISortTH.pressToSort');
};
const Arrow = styled('polygon')(({
  $hovered,
  $preferred,
  $selected,
  theme
}) => {
  return Object.assign({}, $selected && {
    fill: theme.color['icon-interactive-default']
  }, $preferred && $hovered && {
    fill: theme.color['icon-core-default']
  });
});
const StyledSpan = styled.span.withConfig({
  displayName: "TableSortArrows__StyledSpan",
  componentId: "pjefub-0"
})(({
  theme,
  $cssStyles
}) => {
  return Object.assign({
    display: 'inline-block',
    fill: theme.color['icon-interactive-disabled'],
    flexShrink: 0,
    marginLeft: `calc(${theme.space[50]} + ${theme.space[100]})`,
    marginRight: theme.space[0],
    width: '7.5px'
  }, $cssStyles);
});
export const TableSortArrows = props => {
  const {
    domProps,
    tokenProps,
    callbackProps,
    restProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const {
    hovered,
    preferredSort,
    sort
  } = restProps;
  return /*#__PURE__*/_jsx(StyledSpan, Object.assign({}, domProps, callbackProps, restProps, {
    "aria-label": getLabelText(sort),
    "aria-live": "polite",
    $cssStyles: cssStyles,
    children: /*#__PURE__*/_jsxs("svg", {
      role: "presentation",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 7.5 14",
      children: [/*#__PURE__*/_jsx(Arrow, {
        $hovered: hovered,
        points: "7.5 5 0 5 3.75 0 7.5 5",
        $preferred: preferredSort === 'ascending' || sort === 'descending',
        $selected: sort === 'ascending'
      }), /*#__PURE__*/_jsx(Arrow, {
        $hovered: hovered,
        points: "0 9 7.5 9 3.75 14 0 9",
        $preferred: preferredSort === 'descending' || sort === 'ascending',
        $selected: sort === 'descending'
      })]
    })
  }));
};